import { getCurrentLocale } from './../../localization';

export default class HistoryUtil {

    static setHistory(history) {
        this.history = history;
        window.historyUtil = this;
    }

    static getHistory() {
        try {
            return this.history;
        } catch (err) {
            console.log(err);
            return null;
        }
    }

    static push(path, lang) {
        console.log('Navigating to ' + path);
        if (lang)
            this.history.push("/" + lang + path);
        else
            this.history.push("/" + getCurrentLocale() + path);
    }

    static replace(path, lang) {
        console.log('Navigating (replace) to ' + path);
        if (lang)
            this.history.replace("/" + lang + path);
        else
            this.history.replace("/" + getCurrentLocale() + path);
    }

    static pop() {
        this.history.goBack();
    }
}